import DynamicSection from "blocks/dynamic-section/dynamic-section";
import classNames from "classnames";
import SchemaSet from "components/schema-set/schema-set";
import SEO from "components/seo/seo";
import Layout from "layout/layout";
/**
 * External dependencies.
 */
import React from "react";
/**
 * Internal dependencies.
 */
import { fetchAPI, getSlug, getStaticPropsPage } from "utils";

import type { GetStaticProps, GetStaticPaths } from "next";

const Page = ({ data }: any) => {
  const slug = getSlug(data.attributes);

  return (
    <Layout
      title="Details"
      desc="Details"
      light={!data.attributes.DarkHeader}
      dark={data.attributes.DarkContent}
      FooterAlt={data.attributes.FooterAlt}
      className={classNames({
        "template-page": slug,
        [`template-${slug}`]: slug,
        [`${data.attributes.CustomClassName}`]: data.attributes.CustomClassName,
      })}
      notice
    >
      {data.attributes?.CustomCSS && data.attributes?.CustomCSS !== "" && (
        <style>{data.attributes?.CustomCSS}</style>
      )}
      <SEO data={data.attributes.SEO} />
      <SchemaSet
        schemaData={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: data.attributes.Title,
        }}
      />
      {data?.attributes?.Sections && (
        <DynamicSection
          data={data.attributes.Sections}
          slug={data.attributes.slug}
        />
      )}
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = ctx =>
  getStaticPropsPage(ctx, "/pages");

export const getStaticPaths: GetStaticPaths = async () => {
  let paths: any = [];

  const { data } = await fetchAPI("/pages", {
    populate: "*",
  });

  let globalAttrs: any = {
    Home: null,
  };

  const globalResponse = await fetchAPI("/global", {
    populate: {
      Home: {
        populate: "*",
      },
      page: {
        populate: "*",
      },
      localizations: "*",
    },
  });

  if (globalResponse?.data?.attributes) {
    globalAttrs = globalResponse?.data?.attributes;
  }

  const {
    Home: { page: { data: { id: homeID } } = { data: { id: {} } } },
  }: any = globalAttrs;

  data?.map(({ attributes, id }: any) => {
    if (
      (process.env.NEXT_PUBLIC_PRODUCTION === "true" &&
        attributes.HideOnLive) ||
      id === homeID
    ) {
      return;
    }

    if (attributes.localizations.data.length) {
      attributes?.localizations?.data?.map((item: any) => {
        const getSelectedHomepage = globalAttrs?.localizations?.data?.find(
          (locItem: any) =>
            locItem.attributes.locale === item.attributes.locale,
        );

        if (item?.id === getSelectedHomepage?.id) {
          return;
        }

        paths.push({
          params: {
            slug: getSlug(item.attributes),
          },
          locale: item.attributes.locale.toLowerCase(),
        });
      });
    }

    if (!attributes?.theme?.data) {
      paths.push({
        params: { slug: getSlug(attributes) },
        locale: attributes.locale.toLowerCase(),
      });
    }
  });

  return {
    paths,
    fallback: false,
  };
};

export default Page;
